import React from "react";
import { motion, useScroll } from "framer-motion";

function ScrollProgressElement() {
  const { scrollYProgress } = useScroll();

  return (
    <div className="progress-bar-container">
      <motion.div
        className="progress-bar"
        style={{
          scaleX: scrollYProgress,
          backgroundColor: "var(--primary)",
          height: "10px",
        }}
      />
    </div>
  );
}

export default ScrollProgressElement;
